import { render } from "./BackgroundIcon.svg?vue&type=template&id=5b5d368c"
const script = {}
script.render = render

export default script